
export const navigateToFolder = (history: any) => (parentId: string) =>
{
    history.push(`/media/${parentId}`);
};


// WEBPACK FOOTER //
// ./src/util/navigation.ts